 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-home-clients","2":"components-home-contact","3":"components-home-dev-diaries","4":"components-home-our-stack","5":"components-home-philosophy","6":"components-home-projects","9":"component---src-pages-404-js","10":"component---src-templates-glossary-term-jsx","11":"component---src-templates-post-jsx","12":"component---src-templates-project-jsx","13":"static-uploads-blog-cloudfront-png","14":"static-uploads-blog-gatsby-cli-png","15":"static-uploads-blog-vue-apps-nuxt-png","16":"static-uploads-bootstrap-inline-svg","17":"static-uploads-desktop-changemakers-1-jpg","18":"static-uploads-desktop-changemakers-2-jpg","19":"static-uploads-desktop-escreo-1-jpg","20":"static-uploads-desktop-escreo-2-jpg","21":"static-uploads-desktop-innovationship-1-jpg","22":"static-uploads-desktop-innovationship-2-jpg","23":"static-uploads-desktop-tbs-1-jpg","24":"static-uploads-desktop-tbs-2-jpg","25":"static-uploads-es6-inline-svg","26":"static-uploads-escreo-inline-svg","27":"static-uploads-escreo-png","28":"static-uploads-favicon-png","29":"static-uploads-gatsby-inline-svg","30":"static-uploads-graphql-inline-svg","31":"static-uploads-jamstack-inline-svg","32":"static-uploads-jest-inline-svg","33":"static-uploads-kti-logo-inline-svg","34":"static-uploads-laravel-inline-svg","35":"static-uploads-next-changemakers-png","36":"static-uploads-next-escreo-png","37":"static-uploads-next-innovationship-png","38":"static-uploads-next-tbs-png","39":"static-uploads-nodejs-icon-inline-svg","40":"static-uploads-nuxt-inline-svg","41":"static-uploads-opengraph-png","42":"static-uploads-phone-changemakers-1-jpg","43":"static-uploads-phone-changemakers-2-jpg","44":"static-uploads-phone-changemakers-3-jpg","45":"static-uploads-phone-escreo-1-jpg","46":"static-uploads-phone-escreo-2-jpg","47":"static-uploads-phone-escreo-3-jpg","48":"static-uploads-phone-innovationship-1-jpg","49":"static-uploads-phone-innovationship-2-jpg","50":"static-uploads-phone-innovationship-3-jpg","51":"static-uploads-phone-tbs-1-jpg","52":"static-uploads-phone-tbs-2-jpg","53":"static-uploads-phone-tbs-3-jpg","54":"static-uploads-project-changemakers-main-png","55":"static-uploads-project-escreo-main-png","56":"static-uploads-project-innovationship-main-png","57":"static-uploads-project-tbs-main-png","58":"static-uploads-react-inline-svg","59":"static-uploads-sass-inline-svg","60":"static-uploads-sb-tech-inline-svg","61":"static-uploads-sbtech-inline-svg","62":"static-uploads-serverless-inline-svg","63":"static-uploads-tailwindcss-icon-inline-svg","64":"static-uploads-tbs-inline-svg","65":"static-uploads-vue-inline-svg","66":"static-uploads-webpack-inline-svg","67":"static-uploads-woocommerce-inline-svg","68":"static-uploads-wordpress-inline-svg","69":"static-uploads-wordpress-light-svg"}[chunkId]||chunkId) + "-" + {"1":"b7c702b2166286928042","2":"ac857173a4286c3ca6b3","3":"546418b2387f01a7066d","4":"aa053f4a50cafc304ebb","5":"04b1931ad1b7f7e2c275","6":"ad0118456559b636c595","9":"1e629a43f8bdd8484c2a","10":"40a12ea30553f62b42e9","11":"db00078df675fe94b6cd","12":"ff1cd8d0f936cfec7a17","13":"faa406c25f6bfe8fdd56","14":"310420e8739229e10768","15":"12b298041bb11c4f9fcf","16":"442bf819e4b79f6e82e2","17":"d9640582e34b23732906","18":"2f43f437032360b4b686","19":"bde850105f501ad618eb","20":"41496c87ee71be37533b","21":"841c9268a1eec36c8f51","22":"00d6638f5d63bc2efd4e","23":"6eee7a732c2537e96b3e","24":"22527acfea7649d3bb6f","25":"423842469fc8fae26d41","26":"cdec49c3c85e1d49e564","27":"868c38c67c946b8286f4","28":"17b756bfb7c9f24f2e1d","29":"41b6c4c879e6f3ebebe6","30":"ed4d35d171439f46bbd9","31":"d1b20dc92a4ec86bd37c","32":"d9dd9bf555b82c8035fe","33":"ca008e023122ea0fb41b","34":"714b9434cf555b10f109","35":"16926ae9cbdd64ae53ec","36":"edd04ddc786cd2752ada","37":"edeb163e94ec4937ed57","38":"34af01fa310e461f4caa","39":"e8fc5bbaa76467664433","40":"396e4cb661e2426968a7","41":"4770a0c2f91ec8332bed","42":"f8f41bf973c94a7e7b8e","43":"ee7052459f53c4968376","44":"ba383864106bcf3346af","45":"9423ec0b78f7206019bd","46":"556f4b9f1a97820ca898","47":"48bc44526338f359e12b","48":"6f0004d03802b1c8f847","49":"1f97ad4a4be039d4ee5b","50":"342041b4932c3fea9a54","51":"b921ba0f0bec2e81e43d","52":"5c1dd47fda027edc79d8","53":"da5b8d63719d009f154e","54":"eacbb1efe38dd1dbab57","55":"494455788d72bffec27a","56":"f2e1be388ab2e367c549","57":"62699e3231e32c094981","58":"947e7ceef86517fb9894","59":"eb83ee19fd5eb70326a5","60":"f56a5e297ce8c7d54f6d","61":"aef895357e8d4dd6ccf5","62":"2a277d43023ea0f128b4","63":"26fe427a6be73f92b3fd","64":"0695909419cd18465ec9","65":"5a8c7798ff34fd756192","66":"2517a6b9712dd647bfec","67":"37f03ca7b923dc5449d8","68":"a6a03329833da1722341","69":"0908ac102a855bed5c51","71":"6ffb4e52ae88cdb3d947","72":"40793e9a8ec24636b3b1","73":"4332a6106daabb996513","74":"cdc5c1d91559e3c19bba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
